import { Tab, Tabs, ThemeProvider } from "@mui/material";
import React from "react";
import tabsTheme from "../../../newComponent/themeprovider/tabsTheme";

export default function DayTabs({
  days,
  activeDayIndex,
  setActiveDayIndex,
}) {
  return (
    <ThemeProvider theme={tabsTheme}>
      <Tabs
        value={activeDayIndex}
        onChange={(e, newIndex) => {
          setActiveDayIndex(newIndex);
        }}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
      >
        {days.map((day, index) => (
          <Tab
            key={day.id || index}
            value={index}
            label={`Day ${day.day_number}`}
            sx={{color:"#333333"}}
          />
        ))}
      </Tabs>
    </ThemeProvider>
  );
}
